import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

class Link extends Component {
  static propTypes = {
    href: PropTypes.string,
    color: PropTypes.string,
    underline: PropTypes.oneOf(['none', 'dashed', 'solid']),
    blank: PropTypes.bool,
    rel: PropTypes.string
  }

  static defaultProps = {
    href: null,
    color: 'secondary',
    underline: 'none',
    blank: false,
    rel: ''
  }

  constructor(props) {
    super(props)

    this.onClickHandler = this.onClickHandler.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  onClickHandler(proxy) {
    const {onClick} = this.props

    if (onClick) {
      onClick(proxy)
    }
  }

  setRef(ref) {
    this.ref = ref
  }

  click() {
    if (this.ref) {
      this.ref.click()
    }
  }

  focus() {
    if (this.ref) {
      this.ref.focus()
    }
  }

  render() {
    const {
        underline,
        blank,
        className,
        navigate,
        href,
        onClick,
        rel,
        analytics,
        defaultAnalytics,
        match,
        location,
        history,
        staticContext,
        analyticsContexts,
        analyticsOptions,
        overwriteContexts,
        snowplowEvent,
        analyticsText,
        ...props
      } = this.props,
      mergedStyles = [className, styles[underline], styles.link]

    return (
      <Font element="a"
        className={mergedStyles.join(' ')}
        href={href}
        rel={rel}
        ref={this.setRef}
        onClick={this.onClickHandler}
        target={blank ? '_blank' : '_self'}
        {...props}
      />
    )
  }
}

export {Link}

export default Link
